<template>
  <div class="flex gap-4 items-center justify-center h-full">
    <span class="dot animate-bounce1" />
    <span class="dot animate-bounce2" />
    <span class="dot animate-bounce3" />
  </div>
</template>

<style scoped>
.dot {
  @apply size-5 rounded-full bg-#8b8b8b;
}

@keyframes dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.5);
    opacity: 1;
  }
}

.animate-bounce1 {
  animation: dot-bounce 1.4s infinite ease-in-out;
  animation-delay: 0s;
}
.animate-bounce2 {
  animation: dot-bounce 1.4s infinite ease-in-out;
  animation-delay: 0.2s;
}
.animate-bounce3 {
  animation: dot-bounce 1.4s infinite ease-in-out;
  animation-delay: 0.4s;
}
</style>
